import { LabelDropdownMenu } from './dropdown-menu';
import { LabelColorPicker } from './label-form';
import { Popover, PopoverContent } from '@src/design-system/popover';
import type { TLabel } from '@shared/types/label';
import labelApi from '../services/label-api';
import { InfiniteList } from '@src/design-system/molecules/infinite-list';
import LabelsTrigger from './labels-trigger';
import { Button } from '@src/design-system/button';

interface LabelsSelectProps {
  labels?: TLabel[];
  onChange: (item: TLabel) => void;
  showSelectedLabels?: boolean;
  onSaveSelectedLabels?: () => void;
  isBulkAssignLabelsPending?: boolean;
}
export const LabelsSelect: React.FC<LabelsSelectProps> = ({
  labels: selected = [],
  onChange,
  showSelectedLabels,
  onSaveSelectedLabels,
  isBulkAssignLabelsPending,
}) => {
  return (
    <Popover>
      {showSelectedLabels && selected.length > 0 ? (
        <div className='p-3 pb-2 space-y-2'>
          <p className='text-gray-800 font-medium text-sm'>Selected Labels</p>
          {selected.length && (
            <div className='flex items-center flex-wrap max-h-[110px] overflow-auto scrollbar-gray space-x-1 gap-y-2 border border-primary-200 rounded-md p-2'>
              {selected &&
                selected.map((label) => (
                  <LabelDropdownMenu
                    key={label.id}
                    label={label}
                    isSelected={true}
                    toggleLabel={onChange}
                  />
                ))}
            </div>
          )}
        </div>
      ) : null}
      <div className='relative'>
        <InfiniteList
          enableSearch
          fetchInfiniteData={labelApi.useFetchInfinite}
          query={{
            page_size: 30,
          }}
          props={{
            listContainerProps: {
              className: 'max-w-[340px] max-h-[200px] min-h-auto relative',
            },
            listProps: {
              className: 'flex flex-row flex-wrap gap-2 items-start pb-10',
            },
            searchContainerProps: {
              className: 'pt-2 pb-0',
            },
            searchInputProps: {
              inputClassName: 'bg-[#FCFAFF] p-0 rounded-xl',
              className: 'px-2 py-1 rounded-xl',
              placeholder: 'Search...',
            },
          }}
          searchParamName='labelName'
          transformItems={(items) => {
            const unSelectedLabels = items.filter(
              (label) => !selected.some((item) => item.id === label.id)
            );
            return unSelectedLabels;
          }}
          renderItem={(label) => {
            return (
              <LabelDropdownMenu
                key={label.id}
                label={label}
                isSelected={false}
                toggleLabel={onChange}
              />
            );
          }}
        />
        <div className='absolute bottom-0 right-0 z-10 flex-shrink-0 w-[40px] rounded-xl h-[40px] flex items-center justify-center bg-white'>
          <LabelsTrigger />
        </div>
      </div>
      {showSelectedLabels ? (
        <Button
          disabled={isBulkAssignLabelsPending || selected.length === 0}
          isLoading={isBulkAssignLabelsPending}
          className='w-[95%] m-2 rounded-full h-9'
          onClick={selected.length > 0 ? onSaveSelectedLabels : undefined}
        >
          Save
        </Button>
      ) : null}

      <PopoverContent
        className='w-[250px] bg-white border rounded-lg p-0'
        withPortal={true}
        side='left'
      >
        <LabelColorPicker />
      </PopoverContent>
    </Popover>
  );
};
